var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnlikeIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.47446L2 16.8592M6.54532 6.05753L10.247 2.35592C10.4749 2.12803 10.784 2 11.1063 2C11.9787 2 12.5669 2.892 12.2233 3.69385L11.6085 5.12826C11.3382 5.75905 11.203 6.07444 11.2093 6.33025C11.2203 6.77847 11.4859 7.18119 11.8935 7.3679C12.1262 7.47446 12.4693 7.47446 13.1556 7.47446H14.0481C15.5557 7.47446 16.3094 7.47446 16.8488 7.78113C17.3222 8.0503 17.6872 8.47574 17.8812 8.98453C18.1023 9.56421 17.9877 10.3092 17.7585 11.7992L17.3494 14.4582C17.1756 15.5879 17.0887 16.1527 16.8118 16.5771C16.5677 16.9512 16.222 17.2478 15.8151 17.4322C15.3535 17.6413 14.782 17.6413 13.639 17.6413H8.10028C6.78625 17.6413 6.12924 17.6413 5.62735 17.3856C5.18587 17.1607 4.82694 16.8017 4.60199 16.3603C4.34626 15.8584 4.34626 15.2014 4.34626 13.8874V11.3664C4.34626 10.2187 4.34626 9.6448 4.47592 9.10476C4.59087 8.62597 4.78047 8.16825 5.03775 7.74841C5.32795 7.27487 5.73374 6.86909 6.54532 6.05753Z",
    stroke: "#4D6EF5",
    fill: "#4D6EF5",
    strokeWidth: 0.938492,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnlikeIcon);
export default ForwardRef;